export default class Emergencia {

    registroAdmision=[
        {valor:false, descripcion:"", tipo:0 ,label:"Forma de llegada"},
        {valor:false, descripcion:"", tipo:1 ,label:"Ambulatorio"},
        {valor:false, descripcion:"", tipo:1 ,label:"Ambulancia"},
        {valor:false, descripcion:"", tipo:1 ,label:"Otro transporte"},
        {valor:false, descripcion:"", tipo:2 ,label:"Fuente de información"},
        {valor:false, descripcion:"", tipo:2 ,label:"Institución o persona que entrega al paciente"},
        {valor:false, descripcion:"", tipo:2 ,label:"No. Teléfono"}
    ]
    inicioAtencionMotivo=[
        {valor:false, descripcion:"", tipo:2 ,label:"Hora"},
        {valor:false, descripcion:"", tipo:1 ,label:"Trauma"},
        {valor:false, descripcion:"", tipo:1 ,label:"Causa clínica"},
        {valor:false, descripcion:"", tipo:1 ,label:"Causa G. Obstétrica"},
        {valor:false, descripcion:"", tipo:1 ,label:"Causa quirúrgica"},
        {valor:false, descripcion:"", tipo:1 ,label:"Notificación a la policía"},
        {valor:false, descripcion:"", tipo:2 ,label:"Otro motivo"},
        {valor:false, descripcion:"", tipo:2 ,label:"Grupo sanguíneo y factor Rh"}
    ]
    accidenteViolencia=[
        {valor:false, descripcion:"", tipo:2 ,label:"Fecha y hora del evento"},
        {valor:false, descripcion:"", tipo:2 ,label:"Lugar del evento"},
        {valor:false, descripcion:"", tipo:2 ,label:"Dirección del evento"},
        {valor:false, descripcion:"", tipo:1 ,label:"Custodia policial"},
        {valor:false, descripcion:"", tipo:1 ,label:"Accidente de tránsito"},
        {valor:false, descripcion:"", tipo:1 ,label:"Caída"},
        {valor:false, descripcion:"", tipo:1 ,label:"Quemadura"},
        {valor:false, descripcion:"", tipo:1 ,label:"Mordedura"},
        {valor:false, descripcion:"", tipo:1 ,label:"Ahogamiento"},
        {valor:false, descripcion:"", tipo:1 ,label:"Cuerpo extraño"},
        {valor:false, descripcion:"", tipo:1 ,label:"Aplastamiento"},
        {valor:false, descripcion:"", tipo:1 ,label:"Otro accidente"},
        {valor:false, descripcion:"", tipo:1 ,label:"Violencia arma de fuego"},
        {valor:false, descripcion:"", tipo:1 ,label:"Violencia arma cortopunzante"},
        {valor:false, descripcion:"", tipo:1 ,label:"Violencia riña"},
        {valor:false, descripcion:"", tipo:1 ,label:"Violencia familiar"},
        {valor:false, descripcion:"", tipo:1 ,label:"Abuso físico"},
        {valor:false, descripcion:"", tipo:1 ,label:"Abuso psicológico"},
        {valor:false, descripcion:"", tipo:1 ,label:"Abuso sexual"},
        {valor:false, descripcion:"", tipo:1 ,label:"Otra violencia"},
        {valor:false, descripcion:"", tipo:1 ,label:"Intoxicación alcohólica"},
        {valor:false, descripcion:"", tipo:1 ,label:"Intoxicación alimentaria"},
        {valor:false, descripcion:"", tipo:1 ,label:"Intoxicación drogas"},
        {valor:false, descripcion:"", tipo:1 ,label:"Inhalación de gases"},
        {valor:false, descripcion:"", tipo:1 ,label:"Otra intoxicación"},
        {valor:false, descripcion:"", tipo:1 ,label:"Envenenamiento"},
        {valor:false, descripcion:"", tipo:1 ,label:"Picadura"},
        {valor:false, descripcion:"", tipo:1 ,label:"Anafilaxia"},
        {valor:false, descripcion:"", tipo:1 ,label:"Aliento etílico"},
        {valor:false, descripcion:"", tipo:2 ,label:"Valor alcocheck"}
    ]
    antecedenterPersonalesFamiliares=[
        {valor:false, descripcion:"", tipo:1 ,label:"1. Alérgico"},
        {valor:false, descripcion:"", tipo:1 ,label:"2. Clínico"},
        {valor:false, descripcion:"", tipo:1 ,label:"3. Ginecológico"},
        {valor:false, descripcion:"", tipo:1 ,label:"4. Traumatológico"},
        {valor:false, descripcion:"", tipo:1 ,label:"5. Quirúrgico"},
        {valor:false, descripcion:"", tipo:1 ,label:"6. Farmacológico"},
        {valor:false, descripcion:"", tipo:1 ,label:"7. Psiquiátrico"},
        {valor:false, descripcion:"", tipo:1 ,label:"8. Otro"}
    ]
    enfermedadActual=[
        {valor:false, descripcion:"", tipo:1 ,label:"Vía aérea libre"},
        {valor:false, descripcion:"", tipo:1 ,label:"Vía aérea obstruida"},
        {valor:false, descripcion:"", tipo:1 ,label:"Condición estable"},
        {valor:false, descripcion:"", tipo:1 ,label:"Condición inestable"}
    ]
    signosVitales=[
        {valor:false, descripcion:"", tipo:2 ,label:"Presión arterial"},
        {valor:false, descripcion:"", tipo:2 ,label:"F. Cardiaca min"},
        {valor:false, descripcion:"", tipo:2 ,label:"F. Respirotaria min"},
        {valor:false, descripcion:"", tipo:2 ,label:"Temp. bucal C"},
        {valor:false, descripcion:"", tipo:2 ,label:"Temp. axilar C"},
        {valor:false, descripcion:"", tipo:2 ,label:"Peso Kg"},
        {valor:false, descripcion:"", tipo:2 ,label:"Talla m"},
        {valor:false, descripcion:"", tipo:2 ,label:"Ocular 4"},
        {valor:false, descripcion:"", tipo:2 ,label:"Verbal 5"},
        {valor:false, descripcion:"", tipo:2 ,label:"Motora 6"},
        {valor:false, descripcion:"", tipo:2 ,label:"Total 15"},
        {valor:false, descripcion:"", tipo:2 ,label:"Reacc. pupila der."},
        {valor:false, descripcion:"", tipo:2 ,label:"Reacc. pupila izq."},
        {valor:false, descripcion:"", tipo:2 ,label:"T. llenado capilar"},
        {valor:false, descripcion:"", tipo:2 ,label:"Saturación oxígeno"}
    ]
    examenFisicoDiagnostico=[
        {valor:false, descripcion:"", tipo:1 ,label:"1. Vía aérea obstruída"},
        {valor:false, descripcion:"", tipo:1 ,label:"2. Cabeza"},
        {valor:false, descripcion:"", tipo:1 ,label:"3. Cuello"},
        {valor:false, descripcion:"", tipo:1 ,label:"4. Tórax"},
        {valor:false, descripcion:"", tipo:1 ,label:"5. Abdomen"},
        {valor:false, descripcion:"", tipo:1 ,label:"6. Columna"},
        {valor:false, descripcion:"", tipo:1 ,label:"7. Pelvis"},
        {valor:false, descripcion:"", tipo:1 ,label:"8. Extremidades"}
    ]
    emergenciaObstetrica=[
        {valor:false, descripcion:"", tipo:2 ,label:"Gestas"},
        {valor:false, descripcion:"", tipo:2 ,label:"Partos"},
        {valor:false, descripcion:"", tipo:2 ,label:"Abortos"},
        {valor:false, descripcion:"", tipo:2 ,label:"Cesáreas"},
        {valor:false, descripcion:"", tipo:2 ,label:"Fec. última menstruación"},
        {valor:false, descripcion:"", tipo:2 ,label:"Semanas gestación"},
        {valor:false, descripcion:"", tipo:2 ,label:"Movimiento fetal"},
        {valor:false, descripcion:"", tipo:2 ,label:"Frecuencia C. fetal"},
        {valor:false, descripcion:"", tipo:2 ,label:"Membranas rotas"},
        {valor:false, descripcion:"", tipo:2 ,label:"Tiempo"},
        {valor:false, descripcion:"", tipo:2 ,label:"Altura uterina"},
        {valor:false, descripcion:"", tipo:2 ,label:"Presentación"},
        {valor:false, descripcion:"", tipo:2 ,label:"Dilatación"},
        {valor:false, descripcion:"", tipo:2 ,label:"Borramiento"},
        {valor:false, descripcion:"", tipo:2 ,label:"Plano"},
        {valor:false, descripcion:"", tipo:2 ,label:"Pelvis"},
        {valor:false, descripcion:"", tipo:2 ,label:"Sangrado vaginal"},
        {valor:false, descripcion:"", tipo:2 ,label:"Contracciones"}
    ]
    solicitudExamenes=[
        {valor:false, descripcion:"", tipo:1 ,label:"1. Biometría"},
        {valor:false, descripcion:"", tipo:1 ,label:"2. Uroanálisis"},
        {valor:false, descripcion:"", tipo:1 ,label:"3. Química sanguínea"},
        {valor:false, descripcion:"", tipo:1 ,label:"4. Electrolitos"},
        {valor:false, descripcion:"", tipo:1 ,label:"5. Gasometría"},
        {valor:false, descripcion:"", tipo:1 ,label:"6. Electrocardiograma"},
        {valor:false, descripcion:"", tipo:1 ,label:"7. Endoscopía"},
        {valor:false, descripcion:"", tipo:1 ,label:"8. RX tórax"},
        {valor:false, descripcion:"", tipo:1 ,label:"9. RX abdomen"},
        {valor:false, descripcion:"", tipo:1 ,label:"10. RX pelvis"},
        {valor:false, descripcion:"", tipo:1 ,label:"11. Tomografía"},
        {valor:false, descripcion:"", tipo:1 ,label:"12. Resonancia"},
        {valor:false, descripcion:"", tipo:1 ,label:"13. Ecografía pélvica"},
        {valor:false, descripcion:"", tipo:1 ,label:"14. Ecografía abdomen"},
        {valor:false, descripcion:"", tipo:1 ,label:"15. Interconsulta"},
        {valor:false, descripcion:"", tipo:1 ,label:"16. Otros"}
    ]
    alta=[
        {valor:false, descripcion:"", tipo:1 ,label:"1. Domicilio"},
        {valor:false, descripcion:"", tipo:1 ,label:"2. Consulta externa"},
        {valor:false, descripcion:"", tipo:1 ,label:"3. Observación"},
        {valor:false, descripcion:"", tipo:1 ,label:"4. Internación"},
        {valor:false, descripcion:"", tipo:1 ,label:"5. Referencia"},
        {valor:false, descripcion:"", tipo:1 ,label:"6. Egresa vivo"},
        {valor:false, descripcion:"", tipo:1 ,label:"7. En condición estable"},
        {valor:false, descripcion:"", tipo:1 ,label:"8. En condición inestable"},
        {valor:false, descripcion:"", tipo:1 ,label:"9. Muerto en emergencia"},
        {valor:false, descripcion:"", tipo:2 ,label:"Días de incapacidad"},
        {valor:false, descripcion:"", tipo:2 ,label:"Servicio de referencia"},
        {valor:false, descripcion:"", tipo:2 ,label:"Establecimiento"},
        {valor:false, descripcion:"", tipo:2 ,label:"Causa"}
    ]

}



// WEBPACK FOOTER //
// ./src/model/Emergencia.js